module.exports = __webpack_public_path__ + "c0e1e787f18709d35ba66499e0a8c44c.svg";